import * as Yup from "yup";

///login valid///
  export const loginValidateSchema = Yup.object().shape({
    email: Yup.string().email("Please enter a valid email").required("This field is required"),
    password: Yup.string().required("This field is required"),
  
  });
  

  ///forgot valid///
  export const forgotValidateSchema = Yup.object().shape({
    email: Yup.string().email("Please enter a valid email").required("This field is required"),
  });
  
    ///otp valid///
    export const otpValidateSchema = Yup.object({
      otp: Yup.string()
        .length(6, 'OTP must be exactly 6 digits')
        .required('OTP is required'),
    })


  ///Create Class ValidateSchema //

  Yup.addMethod(Yup.string, 'firstLetterUppercase', function (message) {
    return this.test('firstLetterUppercase', message, function (value) {
      const { path, createError } = this;
      return (
        value && /^[A-Z]/.test(value) || createError({ path, message })
      );
    });
  });
  
  export const CreateClassValidateSchema = Yup.object().shape({
    name: Yup.string()
      .required("This field is required"),
    year: Yup.string().required("This field is required"),
  });
  ///Create teacher ValidateSchema //

  export const CreateTeacherValidateSchema = Yup.object().shape({
    firstName: Yup.string().required("This field is required").firstLetterUppercase("First letter must be capitalized"),
    surName: Yup.string().required("This field is required").firstLetterUppercase("First letter must be capitalized"),
    // group: Yup.string().required("This field is required"),
    email: Yup.string()
    .email("Please enter a valid email")
    .required("This field is required")
    .test('first-letter-lowercase', 'The first letter of the email must be lowercase', (value) => {
      if (!value) return true;
      return value[0] === value[0].toLowerCase();
    }),
  });

   ///Create teacher ValidateSchema //

   export const ForgotvalidateSchema = Yup.object().shape({
    oldpassword: Yup.string().required("This field is required") ,
    newpassword:Yup.string().required("This field is required"),
    confirmedpassword:Yup.string().required("This field is required").oneOf([Yup.ref('newpassword')], 'Passwords must match') ,
  });

  export const setPassvalidateSchema = Yup.object().shape({
    newpassword:Yup.string().required("This field is required"),
    confirmedpassword:Yup.string().required("This field is required").oneOf([Yup.ref('newpassword')], 'Passwords must match') ,
  });


  